// src/UI/Select/styles.ts
import styled from "styled-components";

/**
 * StyledSelect — стилизованный <select> на базе styled-components.
 * Принимает пропсы вида $height, $fontSize и т.д. (с префиксом $),
 * чтобы избежать конфликтов с обычными HTML-атрибутами.
 */
export const StyledSelect = styled.select<{
  $height: string;
  $fontSize: string;
  $paddingX: string;
  $gap: string;
  $borderRadius: string;
}>`
  /* Базовые стили */
  height: ${({ $height }) => $height};
  font-size: ${({ $fontSize }) => $fontSize};
  border-radius: ${({ $borderRadius }) => $borderRadius};
  padding: 0 ${({ $paddingX }) => $paddingX};
  border: 1px solid ${({ theme }) => theme.components?.select?.borderEnabled || "#E5E7EB"};
  background-color: ${({ theme }) => theme.palette.background.regular};
  color: ${({ theme }) => theme.palette.TextAndIcon.primaryBlackBlueEnabled || "#fff"};

 
  text-transform: none;

  /* Убираем дефолтную стрелку браузера */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  outline: none;
  background-position: right 8px center;
  background-repeat: no-repeat;
  /* Пример: можно использовать dataURL со стрелкой или inline-svg */
  background-image: url("data:image/svg+xml,%3Csvg width='10' height='6' viewBox='0 0 10 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L5 5L9 1' stroke='%23666' stroke-width='1.5'/%3E%3C/svg%3E");

  /* Прячем стрелку в IE/Edge */
  &::-ms-expand {
    display: none;
  }

  /* Ховер/Фокус */
  &:hover {
    border-color: ${({ theme }) => theme.components?.select?.borderHovered || "#cfcfcf"};
  }
  &:focus {
    border-color: ${({ theme }) => theme.components?.select?.borderFocused || "#a0a0a0"};
  }

  /* Disabled */
  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
    border-color: ${({ theme }) => theme.components?.select?.borderDisabled || "#ddd"};
    background-color: ${({ theme }) => theme.components?.select?.backgroundDisabled || "#f9f9f9"};
    color: ${({ theme }) => theme.components?.select?.contentDisabled || "#aaa"};
  }
`;
